import { render, staticRenderFns } from "./ExtendFatNutrients.vue?vue&type=template&id=9a6d4afa&scoped=true"
import script from "./ExtendFatNutrients.vue?vue&type=script&lang=ts"
export * from "./ExtendFatNutrients.vue?vue&type=script&lang=ts"
import style0 from "./ExtendFatNutrients.vue?vue&type=style&index=0&id=9a6d4afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6d4afa",
  null
  
)

export default component.exports